import axios from 'axios'
import JSEncrypt from 'jsencrypt'
import router from '../router'



// const baseURL ='http://flutter.max.svipss.top/jtgzh'
const baseURL ='/api'
const baseURLA ='/traffic/app_api'
// const baseURL ='/api'
// const baseURLB ='http://flutter.max.svipss.top'
const baseURLB ='http://www.lnjtgh.com'
// 图片地址

export default {
    get,
    post,
    put,
    del,
    baseURL,
    baseURLB
}


const service = axios.create({ // 创建服务
    baseURL:baseURL,
    timeout: 100000,// 请求延时
    headers: {//不启用缓存
        'Cache-Control': 'no-cache'
    },
    validateStatus: function (status) {
        return true; // default
    },
})

const service_patch = axios.create({ // 创建服务
    baseURL:baseURLA,
    timeout: 100000,// 请求延时
    headers: {//不启用缓存
        'Cache-Control': 'no-cache'
    },
    validateStatus: function (status) {
        return true; // default
    },
})

function setToken(access_token) {
    service.defaults.headers.common['Authorization'] = access_token;

}
/**
 * GET解析参数
 */
function get(url, params) {
    for (let k in params) {
        if (!params[k] || params[k] === ''|| params[k].length === 0){
            delete params[k]
        }
    }
    return request({
        url: url,
        method: 'GET',
        params
    })
}

/**
 * 请求方法
 */
function post(url, data,redirect) {
    for (let k in data) {
        if (!data[k] || data[k] === ''|| data[k].length === 0){
            delete data[k]
        }
    }
    return request({
        url: url,
        method: 'POST',
        data,
        redirect
    })
}
function put(url, data) {
    for (let k in data) {
        if (!data[k] || data[k] === ''|| data[k].length === 0){
            delete data[k]
        }
    }
    return request({
        url: url,
        method: 'PUT',
        data
    })
}
function del(url, params) {
    for (let k in params) {
        if (!params[k] || params[k] === ''|| params[k].length === 0){
            delete params[k]
        }
    }
    return request({
        url: url,
        method: 'DELETE',
        params
    })
}
/**
 * 这个处理登录方法
 */
function request(obj) {

    // console.error(obj)
    return normal(obj)
}


//正常请求
function normal(obj) {
    return new Promise((resolve, reject) => {
        if(!obj.redirect)
        {
            service(obj).then(res => {
                if (res.status !== 200 || res.data.code === 401 || res.error){
                    // router.push('/login')
                }else{
                    resolve(res.data)
                }
            }).catch(res => {
                // message.error(res.data.msg)
                // router.push('/login')
                reject(res)
            })
        }
        else{
            service_patch(obj).then(res => {
                if (res.status !== 200 || res.data.code === 401 || res.error){
                    // router.push('/login')
                }else{
                    resolve(res.data)
                }
            }).catch(res => {
                // message.error(res.data.msg)
                // router.push('/login')
                reject(res)
            })
        }

    })
}

/**
  * RSA加解密
  */
function encryptRsa(message, publicKey) {
    let jse = new JSEncrypt();
    jse.setPublicKey(publicKey);
    return jse.encrypt(message);
}
